<template>
  <span class="badge-status" :class="isActive ? 'badge-status--active' : 'badge-status--inactive'">
    <span class="badge-dot"></span>
    {{ isActive ? 'Active' : 'Inactive' }}
  </span>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    // Accepts both integer (1/0) and string ('active'/'inactive') for flexibility
    status: { required: true },
  },
  computed: {
    isActive() {
      return this.status === 1 || this.status === true || this.status === '1' || this.status === 'active';
    },
  },
};
</script>

<style scoped>
.badge-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}
.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  display: inline-block;
}
.badge-status--active   { background: #E6F9F0; color: #1A9E5C; }
.badge-status--inactive { background: #FEF0F0; color: #E05252; }
</style>